<script>
  import { Bar, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins
  export default {
    extends: Bar,
    mixins: [reactiveProp],
    name: 'barChart',
    props: ['chartData', 'options'],
    watch: {
      options () {
        this.renderChart(this.chartData, this.options)
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/BarChart.vue